(function(){
    angular.module('tmx-app')
        .directive('tmxTopbar',[tmxTopbarDirective]);

//Directive 
    function tmxTopbarDirective(){
        var directive={
            restrict:'E',
            templateUrl:'common/directives/topbar/topbar.html',
            controller: ['$scope','$state','$translate','$auth','$mdDialog','$window','$mdMedia','CurrentUserService','ToastService','menu',TopBarCtrl],
            controllerAs:'topbarCtrl'
        };
        return directive;
    }


//Controller
    function TopBarCtrl($scope,$state,$translate,$auth,$mdDialog,$window,$mdMedia,CurrentUserService,ToastService,menu){
    //======Initializations========    
        var toolbar=this;
        toolbar.showTenantLogo = false;
        toolbar.showLogo = true;
        toolbar.brandingBannerSrc = APP_CONSTANTS.tenantLogo;
        if(toolbar.brandingBannerSrc){
            toolbar.showTenantLogo = true;
        }

        toolbar.marginVariable=true;

        toolbar.marginVariable = !$mdMedia('xs');
        this.marginFunction = function(){
            if(toolbar.marginVariable==true)
                toolbar.marginVariable=false;
            else
                toolbar.marginVariable=true;
        }
    //first time login
        if (localStorage.getItem("user") == null) {
            ToastService.showCustomToast("error","Local Storage does not contain logged in user data");

            $auth.logout();
            $state.transitionTo('public.login').then(function(){
                   
                var error = "You have been Successfully Logged Out!";
                    // ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(error);
                ToastService.showCustomToast("success", error);
            });       
        } //if end
        else {//user object exists in the local storage          
            toolbar.CurrentUser = CurrentUserService.getUserObject();//getting from local storage                
            toolbar.CurrentUser.Name = toolbar.CurrentUser.firstName + " " + toolbar.CurrentUser.lastName;
          // toolbar.CurrentUser.ImageUrl = toolbar.CurrentUser.ImageUrl;
            toolbar.CurrentUser.ImageUrl = toolbar.CurrentUser.imageUrl;


            if(toolbar.CurrentUser.ImageUrl == undefined || toolbar.CurrentUser.ImageUrl == null
              || toolbar.CurrentUser.ImageUrl == ""){
                toolbar.CurrentUser.ImageUrl = "assets/images/profile.jpg";
            }       
        }


        $scope.$watch(function () { return CurrentUserService.getUser() }, function (newVal, oldVal) {
          
            if (newVal == oldVal) {
                return;
            }
            toolbar.CurrentUser = newVal;
     
        },true);

        $scope.open=function(section){

            if(section.icon=="language"){
                $translate.use(section.language);
            }
            else{
                menu.selectPage(section);

            }

        }

    /////////////////////////////////////////////////////////
        $scope.mdMedia=function(str){
        
            return $mdMedia(str);
        };        
        $scope.$on("toggleTopLogo",toolbar.toggleTopLogo);
      //toolbar config object, controls state of items inside toolbar  
        toolbar.config={
            behind:true,
        //logo variables
            logo: {
                path:"assets/images/",
                name:"logo-white.png",
                show:true
            },
        //search button variables
            search:{
                currentIcon:'search',
                openSearchIcon:'search',
                closeSearchIcon:'remove_circle',
                active:false,
                width:'0px'
            },
        //setting buttton varibles
            setting:{
                show:true
            },
        //more button variables
            more:{
                show:true,

                option:{
                    foldedAside:false
            //clickOutsideToClose:true

                }
            }  
        };

        toolbar.originatorEv=null;


        toolbar.toggleSearch=function(){
            toolbar.config.search.active=!toolbar.config.search.active;
            toolbar.config.search.currentIcon= toolbar.config.search.active ? toolbar.config.search.closeSearchIcon : toolbar.config.search.openSearchIcon;      
        }

        toolbar.openMenu = function($mdOpenMenu, ev) {        

      // toolbar.originatorEv = ev;
            $mdOpenMenu(ev);
        };

        toolbar.toggleFoldLeftbar = function(){
        }

        toolbar.toggleLeftbar=function(){              
            toolbar.showLogo = !toolbar.showLogo;
            $scope.$root.$broadcast("toggleLeftbar");
            this.marginFunction();
            if(this.marginVariable==false){
                
                $(".page-title .layout-align-start-center").removeClass("margin-left--112");
            }
            if(this.marginVariable==true){
                $(".page-title .layout-align-start-center").addClass("margin-left--112");
            }
        };
        toolbar.toggleTopLogo=function(){
            toolbar.config.logo.show=!toolbar.config.logo.show;
        };

        toolbar.getSearchBarSize=function(){
            if(toolbar.config.search.active){
                var topbarHeight=document.getElementById('topbar').clientWidth;
                var leftNavHeight=document.getElementById('site-leftnav').clientWidth; 
                return topbarHeight- (2*leftNavHeight)+'px';  
            }
            else return '0px';  
        }

        if(menu.isOpen==true){  
            $(".page-title .layout-align-start-center").addClass("margin-left--112");
            this.marginVariable=true;
        }
        if(menu.isOpen!=true){

            $(".page-title .layout-align-start-center").removeClass("margin-left--112");
            this.marginVariable=false;
        }
    }//controller function end
})();